import { DraftConfiguration, DraftState } from '@/types';

export const swapConfigurationAction =
  ({ cid: cidA }: DraftConfiguration, { cid: cidB }: DraftConfiguration) =>
  (draft: DraftState) => {
    draft.configurationIds = draft.configurationIds.map((id) => {
      if (id === cidA) {
        return cidB;
      }
      if (id === cidB) {
        return cidA;
      }
      return id;
    });
  };
